import api from './api';

class DashboardReportService {
  getData(dataForm) {
    return api.post('/merchant/report/voucher-redeem', dataForm);
  }

  getDataSlidesShow(page, filter_time = "", from_date, to_date, sortCol = null, sortType = null) {
    return api.get('/merchant/report/slides-show?page='+page+"&time_type="+filter_time+"&from_date="+from_date+"&to_date="+to_date+"&sortCol="+sortCol+"&sortType="+sortType);
  }

  getFilterDataTopupReport() {
    return api.get('/merchant/report/top-up/get-filter-data');
  }

  getDataTopupReport(dataForm) {
    return api.post('/merchant/report/top-up', dataForm);
  }

  getDataExpiryReport(dataForm) {
    return api.post('/merchant/report/value-expiry', dataForm);
  }

  getDataDailyPaymentSummaryReport(dataForm) {
    return api.post('/merchant/report/daily-payment-summary', dataForm);
  }

  getDataUnuploadedReceipt(dataForm) {
    return api.post('/merchant/report/unuploaded-receipts', dataForm);
  }

  getDataVoidTopupReport(dataForm) {
    return api.post('/merchant/report/void-top-up', dataForm);
  }

  getDataPosTransaction(dataForm) {
    return api.post('/merchant/report/pos-transaction', dataForm);
  }

  getDataTransactionByBranch(dataForm) {
    return api.post('/merchant/report/transaction-by-branch', dataForm);
  }

  getDataPosOrderItemReport(dataForm) {
    return api.post('/merchant/report/pos-order-item-report', dataForm);
  }

  getDataOnlineOrderingReport(dataForm) {
    return api.post('/merchant/report/online-ordering', dataForm);
  }

  getOrderDetail(dataForm) {
    return api.post('/merchant/report/online-ordering/order-detail', dataForm);
  }

  getDataWalletReport(dataForm) {
    return api.post('/merchant/report/pos-wallet-report', dataForm);
  }

  getDataMemberBalancePointsReport(dataForm) {
    return api.post('/merchant/report/member-balance-points-report', dataForm);
  }

  getDataPointReport(dataForm) {
    return api.post('/merchant/report/point-report', dataForm);
  }

  getDataPaidMembershipReport(dataForm) {
    return api.post('/merchant/report/paid-membership', dataForm);
  }

  getDataMemberVoucherReport(dataForm) {
    return api.post('/merchant/report/member-voucher', dataForm);
  }

  getMemberVoucherBundleDetail(memberVoucherBundleId) {
    return api.post('/merchant/report/member-voucher/bundle/' + memberVoucherBundleId);
  }

  getDataDonateReport(dataForm) {
    return api.post('/merchant/report/donate', dataForm);
  }

  getWaReport(dataForm) {
    return api.post('/merchant/report/wa-summary', dataForm);
  }

  getDataItemPickupReport(dataForm) {
    return api.post('/merchant/report/pickup-items', dataForm);
  }
}

export default new DashboardReportService();
